<template>
  <div id="app" :style="isBigScreenPreview() ? Object.assign(bgStyle) : ''">
    <router-view></router-view>
  </div>
</template>
<script>
let themeColors = {
  bigScreenThemeColor: {
    rootBgColor: "#091333",
    leftMenuBgColor: "#1f2124",
    elCollapseItemHeaderBgColor: "#282a2e",
    elCollapseItemWrapBgColor: "#1f2124",
    elCollapseItemHeaderColor: "rgba(255, 255, 255, 0.8)",
    elCollapseItemContentColor: "rgba(255, 255, 255, 0.8)",
    elTreeActiveColor: "#1770FF",
    elTreeHoverColor: "rgba(23, 112, 255, 0.1)",
    elCollapseItemBorderColor: "rgba(0, 0, 0, 0.8)",
    editBgColor: "#131418",
    text: "rgba(255, 255, 255, 0.8)",
    textColor: "rgba(255, 255, 255, 0.8)",
    sliderBackGround: "#363A40",
    inputBackGround: "rgb(53, 56, 63)",
    inputBorder: "none",
    inputPlaceHolderText: "rgba(255, 255, 255, 0.2)",
    inputIconHoverBgColor: "rgba(255, 255, 255, 0.08)",
    selectArrorIcon: "rgba(255, 255, 255, 0.4)",
    inputSuffixText: "rgba(255, 255, 255, 0.4)",
    alertBackGround: "rgba(255, 255, 255, 0.7)",
    toolbarTipText: "rgba(255,255,255,0.4)",
    themeColor: "#1770ff",
    themeColorHover: "rgba(23, 112, 255, 0.8)",
    themeColorSelectBg: "rgba(43, 103, 255, 0.1)",
    themeColorDisabled: "rgba(23, 112, 255, 0.3)",
    toobarTopBgColor: "#3a3f46",
    cardBgColor: "rgba(41, 44, 49, 1)",
    subTextColor: "rgba(255,255,255,.6)",
    thirdTextColor: "rgba(255,255,255,.4)",
    fourthTextColor: "rgba(255,255,255,.2)",
    styleBgColor: "#131418",
    borderColorFour: "rgba(255, 255, 255, 0.08)",
    colorPickerInputColor: "rgba(233, 233, 233,0)",
    borderColorFive: "rgba(49, 51, 54, 1)",
    dataTableBgColor: "#222222",
    inputBg: "rgb(53,56,63)",
    inputArrowBgColor: "#39414E",
    inputArrowMousedownBgColor: "#75849D",
    inputArrowHoverBgColor: "#505B6D",
    inputDisabledColor: "rgba(255,255,255,0.2)",
    dialogBgColor: "#1F2124",
    rulerBgColor: "rgba(0, 0, 0, 0.8)",
    iconHoverBgColor: "rgba(255, 255, 255, 0.08)",
    borderColorSeven: "rgba(255,255,255,.08)",
    iconHoverBg: "rgba(255,255,255,.04)",
    iconColor: "rgba(255, 255, 255, 0.6)",
    collapsibleItemHeadingColor: "rgba(255, 255, 255, 0.8)",
    collapsibleItemHeadingAfterColor: "rgba(255, 255, 255, 0.4) transparent transparent transparent",
    collapsibleItemHeadingCollapseAfterColor: "transparent transparent transparent rgba(255, 255, 255, 0.4)",
    tipsBgColor: "rgba(0, 13, 34, 0.9)",
    borderColorEight: "transparent",
    borderColorNine: "#313336",
    dataTableAddBgColor: "#2D3136",
    dataAddActiveBgColor: "#131418",
    borderColorTen: "rgba(255, 255, 255, 0.08)",
    operateBoxShadow:
      "0px 6px 16px -8px rgba(0, 0, 0, 0.6), 0px 9px 28px rgba(0, 0, 0, 0.3), 0px 12px 48px 16px rgba(0, 0, 0, 0.2)",
    cellSelectBgColor: "rgba(9, 90, 217, 0.3)",
    selectBorderColor: "#095AD9",
    collapsibleItemContentTextColor: "rgba(255, 255, 255, 0.6)",
    inputNuberHoverThemeBgColor: "rgba(63, 67, 77, 1)",
    borderColorEle: "rgba(255, 255, 255, 0.08)",
    dragMoveBgColor: "rgba(9, 90, 217, 0.3)",
    dragMoveBorderColor: "#095AD9",
    messageTipsBorderColor: "rgba(255, 255, 255, 0.08)",
    messageTipsBackgroundColor: "#3A3F46",
    messageTipsBoxShaow:
      "0px 6px 16px -8px rgba(0, 0, 0, 0.6), 0px 9px 28px rgba(0, 0, 0, 0.3), 0px 12px 48px 16px rgba(0, 0, 0, 0.2)",
    messageTipsBorderStyle: "1px solid rgba(255, 255, 255, 0.08)",
    paddingIconHoverColor: "rgba(255, 255, 255, 0.08)",
    imgDialogIconColor: "rgba(255,255,255,.4)",
    pageBottomSliderBg: "#6e7175",
    checkBoxActiveColor: "#1770FF",
    checkBoxEmptyColor: "#1F2124",
    checkBoxBorder: "1px solid #61656D",
    bgColorPickerInputColor: "rgba(255, 255, 255, 0.8)",
    bgColorPickerInputBgColor: "#35383F",
    bgColorPickerInputLabelColor: "rgba(255, 255, 255, 0.4)",
    selectItemHoverBg: "#1E2939",
    dialogShade: "rgba(0,0,0,0.6)",
    primaryButtonHover: "rgba(43, 103, 255, 0.8)"
  },
  bigScreenListThemeColor: {
    rootBgColor: "#1F2124",
    leftMenuBgColor: "#1f2124",
    selectArrorIcon: "rgba(255,255,255,.4)",
    elCollapseItemHeaderBgColor: "#F2F2F2",
    elCollapseItemWrapBgColor: "#1f2124",
    elCollapseItemHeaderColor: "rgba(0, 0, 0, 0.8)",
    elCollapseItemContentColor: "rgba(0, 0, 0, 0.8)",
    elCollapseItemBorderColor: "rgba(0, 0, 0, 0.08)",
    elTreeActiveColor: "#2B67FF",
    elTreeHoverColor: "rgba(43, 103, 255, 0.1)",
    editBgColor: "#ffffff",
    text: "rgba(255, 255, 255, 0.8)",
    textColor: "rgba(255, 255, 255, 0.8)",
    sliderBackGround: "#363A40",
    inputBackGround: "rgb(53, 56, 63)",
    inputBorder: "1px solid #DCDFE6",
    inputPlaceHolderText: "rgba(255, 255, 255, 0.2)",
    inputIconHoverBgColor: "rgba(240, 242, 247, 1)",
    inputSuffixText: "black",
    inputDisabledColor: "rgba(255,255,255,0.2)",
    thirdTextColor: "rgba(0,0,0,.4)",
    fourthTextColor: "rgba(0,0,0,.2)",
    alertBackGround: "rgba(255, 255, 255, 0.3)",
    toolbarTipText: "rgba(255,255,255,0.4)",
    themeColor: "#2B67FF",
    themeColorHover: "rgba(43, 103, 255, 0.8)",
    themeColorDisabled: "rgba(43, 103, 255, 0.8)",
    toobarTopBgColor: "#ECF1FA",
    cardBgColor: "rgba(251, 252, 253, 1)",
    subTextColor: "rgba(255,255,255,.6)",
    styleBgColor: "rgba(245, 246, 248, 1)",
    borderColorFour: "rgba(255, 255, 255, 0.08)",
    borderColorFive: "rgba(0, 0, 0, 0.07)",
    dataTableBgColor: "#fff",
    inputBg: "rgba(243, 243, 243, 1)",
    inputArrowBgColor: "#39414E",
    inputArrowMousedownBgColor: "#DFE2E9",
    inputArrowHoverBgColor: "#505B6D",
    dialogBgColor: "#1F2124",
    rulerBgColor: "#FCFCFC",
    iconHoverBgColor: "rgba(0, 0, 0, 0.04)",
    borderColorSeven: "rgba(0,0,0,.12)",
    iconHoverBg: "rgba(0,0,0,.06)",
    iconColor: "rgba(113, 121, 137, 1)",
    collapsibleItemHeadingColor: "rgba(255, 255, 255, 0.8)",
    collapsibleItemHeadingAfterColor: "rgba(255, 255, 255, 0.4) transparent transparent transparent",
    collapsibleItemHeadingCollapseAfterColor: "transparent transparent transparent rgba(255, 255, 255, 0.4)",
    borderColorEight: "rgb(233, 233, 233)",
    borderColorNine: "rgba(0, 0, 0, 0.07)",
    dataTableAddBgColor: "#FFFFFF",
    dataAddActiveBgColor: "#F9F9F9",
    borderColorTen: "#E9E9E9",
    operateBoxShadow:
      "0px 6px 16px -8px rgba(0, 0, 0, 0.08), 0px 9px 28px rgba(0, 0, 0, 0.05), 0px 12px 48px 16px rgba(0, 0, 0, 0.03)",
    cellSelectBgColor: "rgba(29, 114, 248, 0.2)",
    selectBorderColor: "#1D72F8",
    collapsibleItemContentTextColor: "rgba(0, 0, 0, 0.6)",
    inputNuberHoverThemeBgColor: "rgba(63, 67, 77, 1)",
    borderColorEle: "rgba(0, 0, 0, 0.12)",
    messageTipsBorderColor: "#E9E9E9",
    messageTipsBackgroundColor: "#FFFFFF",
    messageTipsBoxShaow: "0px 6px 16px -8px rgba(0, 0, 0, 0.08), 0px 8px 20px rgba(0, 0, 0, 0.12)",
    messageTipsBorderStyle: "none",
    paddingIconHoverColor: "rgba(0, 0, 0, 0.06)",
    imgDialogIconColor: "rgba(255,255,255,.4)",
    pageBottomSliderBg: "#6e7175",
    selectItemHoverBg: "#1E2939",
    checkBoxBorder: "1px solid #61656D",
    dialogShade: "rgba(0,0,0,0.6)"
  },
  homeListThemeColor: {
    topOperationBgColor: "#E25E5D",
    topOperationColor: "rgba(255, 255, 255, 0.8)",
    topOperationAColor: "rgba(255, 255, 255, 0.8)",
    topOperationHoverColor: "rgba(255, 255, 255, 1)",
    rootBgColor: "#ffffff",
    leftMenuBgColor: "#ffffff",
    selectArrorIcon: "rgba(0,0,0,.8)",
    elCollapseItemHeaderBgColor: "#F2F2F2",
    elCollapseItemWrapBgColor: "#ffffff",
    elCollapseItemHeaderColor: "rgba(0, 0, 0, 0.8)",
    elCollapseItemContentColor: "rgba(0, 0, 0, 0.8)",
    elCollapseItemBorderColor: "rgba(0, 0, 0, 0.08)",
    elTreeActiveColor: "#2B67FF",
    elTreeHoverColor: "rgba(43, 103, 255, 0.1)",
    editBgColor: "#ffffff",
    text: "rgba(0,0,0,1)",
    textColor: "rgba(0,0,0,.8)",
    sliderBackGround: "#e9e9e9",
    inputBackGround: "rgba(243, 243, 243, 1)",
    inputBorder: "1px solid #DCDFE6",
    inputPlaceHolderText: "rgba(255, 255, 255, 0.2)",
    inputIconHoverBgColor: "rgba(240, 242, 247, 1)",
    inputSuffixText: "black",
    inputDisabledColor: "rgba(0,0,0,0.2)",
    thirdTextColor: "rgba(0,0,0,.4)",
    fourthTextColor: "rgba(0,0,0,.2)",
    alertBackGround: "rgba(255, 255, 255, 0.3)",
    toolbarTipText: "rgba(0,0,0,0.4)",
    themeColor: "#2B67FF",
    themeColorHover: "rgba(43, 103, 255, 0.8)",
    themeColorDisabled: "rgba(43, 103, 255, 0.8)",
    toobarTopBgColor: "#ECF1FA",
    cardBgColor: "rgba(251, 252, 253, 1)",
    subTextColor: "rgba(0, 0, 0, 0.6)",
    styleBgColor: "rgba(245, 246, 248, 1)",
    borderColorFour: "#DEE0E3",
    borderColorFive: "rgba(0, 0, 0, 0.07)",
    dataTableBgColor: "#fff",
    inputBg: "rgba(243, 243, 243, 1)",
    inputArrowBgColor: "#F5F6F8",
    inputArrowMousedownBgColor: "#DFE2E9",
    inputArrowHoverBgColor: "#E9ECF1",
    dialogBgColor: "#fff",
    rulerBgColor: "#FCFCFC",
    iconHoverBgColor: "rgba(0, 0, 0, 0.04)",
    borderColorSeven: "rgba(0,0,0,.12)",
    iconHoverBg: "rgba(0,0,0,.06)",
    iconColor: "rgba(113, 121, 137, 1)",
    collapsibleItemHeadingColor: "rgba(255, 255, 255, 0.8)",
    collapsibleItemHeadingAfterColor: "rgba(255, 255, 255, 0.4) transparent transparent transparent",
    collapsibleItemHeadingCollapseAfterColor: "transparent transparent transparent rgba(255, 255, 255, 0.4)",
    borderColorEight: "rgb(233, 233, 233)",
    borderColorNine: "rgba(0, 0, 0, 0.07)",
    dataTableAddBgColor: "#FFFFFF",
    dataAddActiveBgColor: "#F9F9F9",
    borderColorTen: "#E9E9E9",
    operateBoxShadow:
      "0px 6px 16px -8px rgba(0, 0, 0, 0.08), 0px 9px 28px rgba(0, 0, 0, 0.05), 0px 12px 48px 16px rgba(0, 0, 0, 0.03)",
    cellSelectBgColor: "rgba(29, 114, 248, 0.2)",
    selectBorderColor: "#1D72F8",
    collapsibleItemContentTextColor: "rgba(0, 0, 0, 0.6)",
    inputNuberHoverThemeBgColor: "rgba(235, 235, 235, 1)",
    borderColorEle: "rgba(0, 0, 0, 0.12)",
    messageTipsBorderColor: "#E9E9E9",
    messageTipsBackgroundColor: "#FFFFFF",
    messageTipsBoxShaow: "0px 6px 16px -8px rgba(0, 0, 0, 0.08), 0px 8px 20px rgba(0, 0, 0, 0.12)",
    messageTipsBorderStyle: "none",
    imgDialogIconColor: "rgba(0,0,0,.4)",
    pageBottomSliderBg: "#B7B7B7",
    selectItemHoverBg: "#F0F2F7",
    dialogShade: "rgba(255,255,255,0.6)"
  },
  ssrPreviewThemeColor: {
    topOperationBgColor: "#E25E5D",
    topOperationColor: "rgba(255, 255, 255, 0.8)",
    topOperationAColor: "rgba(255, 255, 255, 0.8)",
    topOperationHoverColor: "rgba(255, 255, 255, 1)",
    rootBgColor: "rgba(245, 246, 248, 1)",
    leftMenuBgColor: "#ffffff",
    selectArrorIcon: "rgba(0,0,0,.8)",
    elCollapseItemHeaderBgColor: "#F2F2F2",
    elCollapseItemWrapBgColor: "#ffffff",
    elCollapseItemHeaderColor: "rgba(0, 0, 0, 0.8)",
    elCollapseItemContentColor: "rgba(0, 0, 0, 0.8)",
    elCollapseItemBorderColor: "rgba(0, 0, 0, 0.08)",
    elTreeActiveColor: "#2B67FF",
    elTreeHoverColor: "rgba(23, 112, 255, 0.1)",
    editBgColor: "#E5E5E5",
    textColor: "rgba(0,0,0,.8)",
    sliderBackGround: "#e9e9e9",
    inputBackGround: "rgba(243, 243, 243, 1)",
    inputBorder: "1px solid #DCDFE6",
    inputPlaceHolderText: "rgba(255, 255, 255, 0.2)",
    inputIconHoverBgColor: "rgba(240, 242, 247, 1)",
    inputSuffixText: "black",
    inputDisabledColor: "rgba(0,0,0,0.2)",
    thirdTextColor: "rgba(0,0,0,.4)",
    fourthTextColor: "rgba(0,0,0,.2)",
    alertBackGround: "rgba(255, 255, 255, 0.3)",
    toolbarTipText: "rgba(0,0,0,0.4)",
    themeColor: "#2B67FF",
    themeColorHover: "rgba(43, 103, 255, 0.8)",
    themeColorDisabled: "rgba(43, 103, 255, 0.8)",
    themeColorSelectBg: "rgba(43, 103, 255, 0.1)",
    toobarTopBgColor: "#ECF1FA",
    cardBgColor: "rgba(251, 252, 253, 1)",
    subTextColor: "rgba(0, 0, 0, 0.6)",
    styleBgColor: "rgba(245, 246, 248, 1)",
    borderColorFour: "#DEE0E3",
    colorPickerInputColor: "rgba(233, 233, 233,1)",
    borderColorFive: "rgba(0, 0, 0, 0.07)",
    dataTableBgColor: "#fff",
    inputBg: "rgba(243, 243, 243, 1)",
    inputArrowBgColor: "#F5F6F8",
    inputArrowMousedownBgColor: "#DFE2E9",
    inputArrowHoverBgColor: "#E9ECF1",
    dialogBgColor: "#fff",
    rulerBgColor: "#FCFCFC",
    iconHoverBgColor: "rgba(0, 0, 0, 0.04)",
    borderColorSeven: "rgba(0,0,0,.12)",
    iconHoverBg: "rgba(0,0,0,.06)",
    iconColor: "rgba(113, 121, 137, 1)",
    collapsibleItemHeadingColor: "rgba(0, 0, 0, 0.8)",
    collapsibleItemHeadingAfterColor: "rgba(0, 0, 0, 0.4) transparent transparent transparent",
    collapsibleItemHeadingCollapseAfterColor: "transparent transparent transparent rgba(0, 0, 0, 0.4)",
    tipsBgColor: "rgba(24, 30, 51, 0.8)",
    borderColorEight: "rgb(233, 233, 233)",
    borderColorNine: "rgba(0, 0, 0, 0.07)",
    dataTableAddBgColor: "#FFFFFF",
    dataAddActiveBgColor: "#F9F9F9",
    borderColorTen: "#E9E9E9",
    operateBoxShadow:
      "0px 6px 16px -8px rgba(0, 0, 0, 0.08), 0px 9px 28px rgba(0, 0, 0, 0.05), 0px 12px 48px 16px rgba(0, 0, 0, 0.03)",
    cellSelectBgColor: "rgba(29, 114, 248, 0.2)",
    selectBorderColor: "#1D72F8",
    collapsibleItemContentTextColor: "rgba(0, 0, 0, 0.6)",
    inputNuberHoverThemeBgColor: "rgba(235, 235, 235, 1)",
    borderColorEle: "rgba(0, 0, 0, 0.12)",
    messageTipsBorderColor: "#E9E9E9",
    messageTipsBackgroundColor: "#FFFFFF",
    messageTipsBoxShaow: "0px 6px 16px -8px rgba(0, 0, 0, 0.08), 0px 8px 20px rgba(0, 0, 0, 0.12)",
    messageTipsBorderStyle: "none",
    paddingIconHoverColor: "rgba(0, 0, 0, 0.06)",
    selectItemHoverBg: "#F0F2F7",
    dialogShade: "rgba(255,255,255,0.6)",
    topOperationIconBgColor: "rgba(51, 112, 255, 0.1)",
  },
  homeThemeColor: {},
  appHomeThemeColor: {}
}
let types = [
  "topOperationBgColor",
  "topOperationSaveColor",
  "topOperationColor",
  "topOperationAColor",
  "topOperationHoverColor",
  "rootBgColor",
  "selectArrorIcon",
  "inputBg",
  "inputArrowBgColor",
  "inputArrowHoverBgColor",
  "inputArrowMousedownBgColor",
  "leftMenuBgColor",
  "dialogBgColor",
  "elCollapseItemHeaderBgColor",
  "elCollapseItemWrapBgColor",
  "elCollapseItemHeaderColor",
  "elCollapseItemContentColor",
  "elCollapseItemBorderColor",
  "elTreeActiveColor",
  "elTreeHoverColor",
  "editBgColor",
  "text",
  "textColor",
  "styleBgColor",
  "subTextColor",
  "thirdTextColor",
  "fourthTextColor",
  "inputBorder",
  "alertBackGround",
  "rulerBgColor",
  "inputSuffixText",
  "sliderBackGround",
  "inputBackGround",
  "inputIconHoverBgColor",
  "inputDisabledColor",
  "toolbarTipText",
  "themeColorIcon",
  "themeColorIconHover",
  "themeColor",
  "themeColorHover",
  "themeColorDisabled",
  "themeColorSelectBg",
  "toobarTopBgColor",
  "iconColor",
  "cardBgColor",
  "borderColorFour",
  "borderColorFive",
  "colorPickerInputColor",
  "dataTableBgColor",
  "iconHoverBgColor",
  "borderColorSeven",
  "iconHoverBg",
  "collapsibleItemHeadingColor",
  "collapsibleItemHeadingAfterColor",
  "collapsibleItemHeadingCollapseAfterColor",
  "tipsBgColor",
  "borderColorEight",
  "borderColorNine",
  "dataTableAddBgColor",
  "dataAddActiveBgColor",
  "operateBoxShadow",
  "cellSelectBgColor",
  "selectBorderColor",
  "collapsibleItemContentTextColor",
  "inputNuberHoverThemeBgColor",
  "borderColorEle",
  "dragMoveBgColor",
  "dragMoveBorderColor",
  "messageTipsBorderColor",
  "messageTipsBackgroundColor",
  "messageTipsBoxShaow",
  "messageTipsBorderStyle",
  "paddingIconHoverColor",
  "imgDialogIconColor",
  "pageBottomSliderBg",
  "checkBoxActiveColor",
  "checkBoxEmptyColor",
  "checkBoxBorder",
  "bgColorPickerInputColor",
  "bgColorPickerInputBgColor",
  "bgColorPickerInputLabelColor",
  "primaryButtonHover",
  "defaultButtonHover",
  "topOperationBorderColor",
  "topOperationIconColor",
  "topOperationIconBgColor",
  "topSubTextColor",
  "topThirdTextColor",
  "topControlHoverBg",
  "topIconDisabled",
  "selectItemHoverBg",
  "dialogShade",
  "previewButtonHover"
]

const preStyleColors = [
  {
    rootBgColor: "#ffffff",
    leftMenuBgColor: "#ffffff",
    selectArrorIcon: "rgba(0,0,0,.8)",
    topOperationBgColor: "#FFFFFF",
    topOperationSaveColor: "#FFFFFF",
    topOperationColor: "rgba(0, 0, 0, 0.8)",
    topOperationAColor: "#2B67FF",
    topOperationHoverColor: "#2B67FF",
    elCollapseItemHeaderBgColor: "#F2F2F2",
    elCollapseItemWrapBgColor: "#ffffff",
    elCollapseItemHeaderColor: "rgba(0, 0, 0, 0.8)",
    elCollapseItemContentColor: "rgba(0, 0, 0, 0.8)",
    elCollapseItemBorderColor: "rgba(0, 0, 0, 0.08)",
    elTreeActiveColor: "#2B67FF",
    elTreeHoverColor: "rgba(23, 112, 255, 0.1)",
    editBgColor: "#F5F6F8",
    text: "rgba(0,0,0,1)",
    textColor: "rgba(0,0,0,.8)",
    sliderBackGround: "#e9e9e9",
    inputBackGround: "rgba(243, 243, 243, 1)",
    inputBorder: "1px solid #DCDFE6",
    inputPlaceHolderText: "rgba(255, 255, 255, 0.2)",
    inputIconHoverBgColor: "rgba(240, 242, 247, 1)",
    inputSuffixText: "black",
    inputDisabledColor: "rgba(0,0,0,0.2)",
    thirdTextColor: "rgba(0,0,0,.4)",
    fourthTextColor: "rgba(0,0,0,.2)",
    alertBackGround: "rgba(255, 255, 255, 0.3)",
    toolbarTipText: "rgba(0,0,0,0.4)",
    themeColorIcon: "#212633",
    themeColorIconHover: "rgba(0, 0, 0, 0.04)",
    themeColor: "#2B67FF",
    themeColorHover: "rgba(43, 103, 255, 0.8)",
    themeColorDisabled: "rgba(43, 103, 255, 0.5)",
    themeColorSelectBg: "rgba(43, 103, 255, 0.1)",
    toobarTopBgColor: "#ECF1FA",
    cardBgColor: "rgba(251, 252, 253, 1)",
    subTextColor: "rgba(0, 0, 0, 0.6)",
    styleBgColor: "rgba(245, 246, 248, 1)",
    borderColorFour: "#DEE0E3",
    colorPickerInputColor: "rgba(233, 233, 233,1)",
    borderColorFive: "rgba(0, 0, 0, 0.07)",
    dataTableBgColor: "#fff",
    inputBg: "rgba(243, 243, 243, 1)",
    inputArrowBgColor: "#F5F6F8",
    inputArrowMousedownBgColor: "#DFE2E9",
    inputArrowHoverBgColor: "#E9ECF1",
    dialogBgColor: "#fff",
    rulerBgColor: "#FCFCFC",
    iconHoverBgColor: "rgba(0, 0, 0, 0.04)",
    borderColorSeven: "rgba(0,0,0,.12)",
    iconHoverBg: "rgba(0,0,0,.06)",
    iconColor: "rgba(113, 121, 137, 1)",
    collapsibleItemHeadingColor: "rgba(0, 0, 0, 0.8)",
    collapsibleItemHeadingAfterColor: "rgba(0, 0, 0, 0.4) transparent transparent transparent",
    collapsibleItemHeadingCollapseAfterColor: "transparent transparent transparent rgba(0, 0, 0, 0.4)",
    tipsBgColor: "rgba(24, 30, 51, 0.8)",
    borderColorEight: "rgb(233, 233, 233)",
    borderColorNine: "rgba(0, 0, 0, 0.07)",
    dataTableAddBgColor: "#FFFFFF",
    dataAddActiveBgColor: "#F9F9F9",
    borderColorTen: "#E9E9E9",
    operateBoxShadow:
      "0px 6px 16px -8px rgba(0, 0, 0, 0.08), 0px 9px 28px rgba(0, 0, 0, 0.05), 0px 12px 48px 16px rgba(0, 0, 0, 0.03)",
    cellSelectBgColor: "rgba(29, 114, 248, 0.2)",
    selectBorderColor: "#1D72F8",
    collapsibleItemContentTextColor: "rgba(0, 0, 0, 0.6)",
    inputNuberHoverThemeBgColor: "rgba(235, 235, 235, 1)",
    borderColorEle: "rgba(0, 0, 0, 0.12)",
    dragMoveBgColor: "rgba(29, 114, 248, 0.2)",
    dragMoveBorderColor: "#1D72F8",
    messageTipsBorderColor: "#E9E9E9",
    messageTipsBackgroundColor: "#FFFFFF",
    messageTipsBoxShaow: "0px 6px 16px -8px rgba(0, 0, 0, 0.08), 0px 8px 20px rgba(0, 0, 0, 0.12)",
    messageTipsBorderStyle: "none",
    paddingIconHoverColor: "rgba(0, 0, 0, 0.06)",
    imgDialogIconColor: "rgba(0,0,0,.4)",
    pageBottomSliderBg: "#B7B7B7",
    checkBoxActiveColor: "#409EFF",
    checkBoxEmptyColor: "#FFFFFF",
    checkBoxBorder: "1px solid rgba(0, 0, 0, 0.14)",
    bgColorPickerInputColor: "rgba(0, 0, 0, 0.8)",
    bgColorPickerInputBgColor: "#F0F0F0",
    bgColorPickerInputLabelColor: "rgba(0, 0, 0, 0.4)",
    defaultButtonHover: "#E8F7FF",
    primaryButtonHover: "rgba(43, 103, 255, 0.8)",
    topOperationBorderColor: "rgba(0, 0, 0, 0.1)",
    topOperationIconColor: "rgba(0, 0, 0, 0.4)",
    topOperationIconBgColor: "rgba(51, 112, 255, 0.1)",
    topSubTextColor: "rgba(0,0,0,0.6)",
    topThirdTextColor: "rgba(0,0,0,.4)",
    topControlHoverBg: "rgba(0, 0, 0, 0.05)",
    topIconDisabled: "rgba(0,0,0,0.3)",
    selectItemHoverBg: "#F0F2F7",
    dialogShade: "rgba(255,255,255,0.6)",
    previewButtonHover: "#E8F7FF",
  },
  {
    rootBgColor: "#ffffff",
    leftMenuBgColor: "#ffffff",
    selectArrorIcon: "rgba(0,0,0,.8)",
    topOperationBgColor: "#E25E5D",
    topOperationSaveColor: "#E25E5D",
    topOperationColor: "rgba(255, 255, 255, 1)",
    topOperationAColor: "rgba(255, 255, 255, 1)",
    topOperationHoverColor: "rgba(255, 255, 255, 1)",
    elCollapseItemHeaderBgColor: "rgba(255, 239, 239, 1)",
    elCollapseItemWrapBgColor: "#ffffff",
    elCollapseItemHeaderColor: "rgba(0, 0, 0, 0.8)",
    elCollapseItemContentColor: "rgba(0, 0, 0, 0.8)",
    elCollapseItemBorderColor: "rgba(0, 0, 0, 0.08)",
    elTreeActiveColor: "#E25E5D",
    elTreeHoverColor: "rgba(23, 112, 255, 0.1)",
    editBgColor: "#F5F6F8",
    text: "rgba(0,0,0,1)",
    textColor: "rgba(0,0,0,.8)",
    sliderBackGround: "#e9e9e9",
    inputBackGround: "rgba(243, 243, 243, 1)",
    inputBorder: "1px solid #DCDFE6",
    inputPlaceHolderText: "rgba(255, 255, 255, 0.2)",
    inputIconHoverBgColor: "rgba(240, 242, 247, 1)",
    inputSuffixText: "black",
    inputDisabledColor: "rgba(0,0,0,0.2)",
    thirdTextColor: "rgba(0,0,0,.4)",
    fourthTextColor: "rgba(0,0,0,.2)",
    alertBackGround: "rgba(255, 255, 255, 0.3)",
    toolbarTipText: "rgba(0,0,0,0.4)",
    themeColorIcon: "rgba(226, 94, 93,1)",
    themeColorIconHover: "rgba(226, 94, 93, 0.05)",
    themeColor: "rgba(226, 94, 93,1)",
    themeColorHover: "rgba(226, 94, 93, 0.8)",
    themeColorDisabled: "rgba(226, 94, 93, 0.5)",
    themeColorSelectBg: "rgba(226, 94, 93, 0.1)",
    toobarTopBgColor: "rgba(255, 248, 248, 1)",
    cardBgColor: "rgba(251, 252, 253, 1)",
    subTextColor: "rgba(0, 0, 0, 0.6)",
    styleBgColor: "rgba(245, 246, 248, 1)",
    borderColorFour: "#DEE0E3",
    colorPickerInputColor: "rgba(233, 233, 233,1)",
    borderColorFive: "rgba(0, 0, 0, 0.07)",
    dataTableBgColor: "#fff",
    inputBg: "rgba(243, 243, 243, 1)",
    inputArrowBgColor: "#F5F6F8",
    inputArrowMousedownBgColor: "#DFE2E9",
    inputArrowHoverBgColor: "#E9ECF1",
    dialogBgColor: "#fff",
    rulerBgColor: "#FCFCFC",
    iconHoverBgColor: "rgba(0, 0, 0, 0.04)",
    borderColorSeven: "rgba(0,0,0,.12)",
    iconHoverBg: "rgba(0,0,0,.06)",
    iconColor: "rgba(113, 121, 137, 1)",
    collapsibleItemHeadingColor: "rgba(0, 0, 0, 0.8)",
    collapsibleItemHeadingAfterColor: "rgba(0, 0, 0, 0.4) transparent transparent transparent",
    collapsibleItemHeadingCollapseAfterColor: "transparent transparent transparent rgba(0, 0, 0, 0.4)",
    tipsBgColor: "rgba(24, 30, 51, 0.8)",
    borderColorEight: "rgb(233, 233, 233)",
    borderColorNine: "rgba(0, 0, 0, 0.07)",
    dataTableAddBgColor: "#FFFFFF",
    dataAddActiveBgColor: "#F9F9F9",
    borderColorTen: "#E9E9E9",
    operateBoxShadow:
      "0px 6px 16px -8px rgba(0, 0, 0, 0.08), 0px 9px 28px rgba(0, 0, 0, 0.05), 0px 12px 48px 16px rgba(0, 0, 0, 0.03)",
    cellSelectBgColor: "rgba(29, 114, 248, 0.2)",
    selectBorderColor: "#1D72F8",
    collapsibleItemContentTextColor: "rgba(0, 0, 0, 0.6)",
    inputNuberHoverThemeBgColor: "rgba(235, 235, 235, 1)",
    borderColorEle: "rgba(0, 0, 0, 0.12)",
    dragMoveBgColor: "rgba(29, 114, 248, 0.2)",
    dragMoveBorderColor: "#1D72F8",
    messageTipsBorderColor: "#E9E9E9",
    messageTipsBackgroundColor: "#FFFFFF",
    messageTipsBoxShaow: "0px 6px 16px -8px rgba(0, 0, 0, 0.08), 0px 8px 20px rgba(0, 0, 0, 0.12)",
    messageTipsBorderStyle: "none",
    paddingIconHoverColor: "rgba(0, 0, 0, 0.06)",
    imgDialogIconColor: "rgba(0,0,0,.4)",
    pageBottomSliderBg: "#B7B7B7",
    checkBoxActiveColor: "#409EFF",
    checkBoxEmptyColor: "#FFFFFF",
    checkBoxBorder: "1px solid rgba(0, 0, 0, 0.14)",
    bgColorPickerInputColor: "rgba(0, 0, 0, 0.8)",
    bgColorPickerInputBgColor: "#F0F0F0",
    bgColorPickerInputLabelColor: "rgba(0, 0, 0, 0.4)",
    defaultButtonHover: "#FFECE8",
    primaryButtonHover: "rgba(255, 255, 255, 0.9)",
    topOperationBorderColor: "rgba(255, 255, 255, 0.32)",
    topOperationIconColor: "rgba(255, 255, 255, 0.8)",
    topOperationIconBgColor: "rgba(255, 255, 255, 0.9)",
    topSubTextColor: "rgba(255, 255, 255, 0.6)",
    topThirdTextColor: "rgba(255, 255, 255, 0.4)",
    topControlHoverBg: "rgba(255, 255, 255, 0.16)",
    topIconDisabled: "rgba(255,255,255,0.3)",
    selectItemHoverBg: "#F0F2F7",
    dialogShade: "rgba(255,255,255,0.6)",
    previewButtonHover: "rgba(255, 255, 255, 0.1)",
  },
  {
    rootBgColor: "#ffffff",
    leftMenuBgColor: "#ffffff",
    selectArrorIcon: "rgba(0,0,0,.8)",
    topOperationBgColor: "rgba(255, 141, 58, 1)",
    topOperationSaveColor: "rgba(255, 141, 58, 1)",
    topOperationColor: "rgba(255, 255, 255, 1)",
    topOperationAColor: "rgba(255, 255, 255, 1)",
    topOperationHoverColor: "rgba(255, 255, 255, 1)",
    elCollapseItemHeaderBgColor: "rgba(255, 240, 229, 1)",
    elCollapseItemWrapBgColor: "#ffffff",
    elCollapseItemHeaderColor: "rgba(0, 0, 0, 0.8)",
    elCollapseItemContentColor: "rgba(0, 0, 0, 0.8)",
    elCollapseItemBorderColor: "rgba(0, 0, 0, 0.08)",
    elTreeActiveColor: "rgba(255, 141, 58, 1)",
    elTreeHoverColor: "rgba(23, 112, 255, 0.1)",
    editBgColor: "#F5F6F8",
    text: "rgba(0,0,0,1)",
    textColor: "rgba(0,0,0,.8)",
    sliderBackGround: "#e9e9e9",
    inputBackGround: "rgba(243, 243, 243, 1)",
    inputBorder: "1px solid #DCDFE6",
    inputPlaceHolderText: "rgba(255, 255, 255, 0.2)",
    inputIconHoverBgColor: "rgba(240, 242, 247, 1)",
    inputSuffixText: "black",
    inputDisabledColor: "rgba(0,0,0,0.2)",
    thirdTextColor: "rgba(0,0,0,.4)",
    fourthTextColor: "rgba(0,0,0,.2)",
    alertBackGround: "rgba(255, 255, 255, 0.3)",
    toolbarTipText: "rgba(0,0,0,0.4)",
    themeColorIcon: "rgba(255, 141, 58, 1)",
    themeColorIconHover: "rgba(252, 150, 82, 0.08)",
    themeColor: "rgba(255, 141, 58, 1)",
    themeColorHover: "rgba(255, 141, 58, .8)",
    themeColorDisabled: "rgba(252, 150, 82, .5)",
    themeColorSelectBg: "rgba(255, 141, 58, .1)",
    toobarTopBgColor: "rgba(255, 247, 242, 1)",
    cardBgColor: "rgba(251, 252, 253, 1)",
    subTextColor: "rgba(0, 0, 0, 0.6)",
    styleBgColor: "rgba(245, 246, 248, 1)",
    borderColorFour: "#DEE0E3",
    colorPickerInputColor: "rgba(233, 233, 233,1)",
    borderColorFive: "rgba(0, 0, 0, 0.07)",
    dataTableBgColor: "#fff",
    inputBg: "rgba(243, 243, 243, 1)",
    inputArrowBgColor: "#F5F6F8",
    inputArrowMousedownBgColor: "#DFE2E9",
    inputArrowHoverBgColor: "#E9ECF1",
    dialogBgColor: "#fff",
    rulerBgColor: "#FCFCFC",
    iconHoverBgColor: "rgba(0, 0, 0, 0.04)",
    borderColorSeven: "rgba(0,0,0,.12)",
    iconHoverBg: "rgba(0,0,0,.06)",
    iconColor: "rgba(113, 121, 137, 1)",
    collapsibleItemHeadingColor: "rgba(0, 0, 0, 0.8)",
    collapsibleItemHeadingAfterColor: "rgba(0, 0, 0, 0.4) transparent transparent transparent",
    collapsibleItemHeadingCollapseAfterColor: "transparent transparent transparent rgba(0, 0, 0, 0.4)",
    tipsBgColor: "rgba(24, 30, 51, 0.8)",
    borderColorEight: "rgb(233, 233, 233)",
    borderColorNine: "rgba(0, 0, 0, 0.07)",
    dataTableAddBgColor: "#FFFFFF",
    dataAddActiveBgColor: "#F9F9F9",
    borderColorTen: "#E9E9E9",
    operateBoxShadow:
      "0px 6px 16px -8px rgba(0, 0, 0, 0.08), 0px 9px 28px rgba(0, 0, 0, 0.05), 0px 12px 48px 16px rgba(0, 0, 0, 0.03)",
    cellSelectBgColor: "rgba(29, 114, 248, 0.2)",
    selectBorderColor: "rgba(255, 141, 58, 1)",
    collapsibleItemContentTextColor: "rgba(0, 0, 0, 0.6)",
    inputNuberHoverThemeBgColor: "rgba(235, 235, 235, 1)",
    borderColorEle: "rgba(0, 0, 0, 0.12)",
    dragMoveBgColor: "rgba(255, 141, 58, .2)",
    dragMoveBorderColor: "rgba(255, 141, 58, 1)",
    messageTipsBorderColor: "#E9E9E9",
    messageTipsBackgroundColor: "#FFFFFF",
    messageTipsBoxShaow: "0px 6px 16px -8px rgba(0, 0, 0, 0.08), 0px 8px 20px rgba(0, 0, 0, 0.12)",
    messageTipsBorderStyle: "none",
    paddingIconHoverColor: "rgba(0, 0, 0, 0.06)",
    imgDialogIconColor: "rgba(0,0,0,.4)",
    pageBottomSliderBg: "#B7B7B7",
    checkBoxActiveColor: "#409EFF",
    checkBoxEmptyColor: "#FFFFFF",
    checkBoxBorder: "1px solid rgba(0, 0, 0, 0.14)",
    bgColorPickerInputColor: "rgba(0, 0, 0, 0.8)",
    bgColorPickerInputBgColor: "#F0F0F0",
    bgColorPickerInputLabelColor: "rgba(0, 0, 0, 0.4)",
    defaultButtonHover: "#FFF7E8",
    primaryButtonHover: "rgba(255, 255, 255, 0.9)",
    topOperationBorderColor: "rgba(255, 255, 255, 0.32)",
    topOperationIconColor: "rgba(255, 255, 255, 0.8)",
    topOperationIconBgColor: "rgba(255, 255, 255, 0.9)",
    topSubTextColor: "rgba(255, 255, 255, 0.6)",
    topThirdTextColor: "rgba(255, 255, 255, 0.4)",
    topControlHoverBg: "rgba(255, 255, 255, 0.16)",
    topIconDisabled: "rgba(255,255,255,0.3)",
    selectItemHoverBg: "#F0F2F7",
    dialogShade: "rgba(255,255,255,0.6)",
    previewButtonHover: "rgba(255, 255, 255, 0.1)",
  },
  {
    rootBgColor: "#ffffff",
    leftMenuBgColor: "#ffffff",
    selectArrorIcon: "rgba(0,0,0,.8)",
    topOperationBgColor: "rgba(0, 133, 133, 1)",
    topOperationSaveColor: "rgba(0, 133, 133, 1)",
    topOperationColor: "rgba(255, 255, 255, 1)",
    topOperationAColor: "rgba(255, 255, 255, 1)",
    topOperationHoverColor: "rgba(255, 255, 255, 1)",
    elCollapseItemHeaderBgColor: "rgba(235, 248, 248, 1)",
    elCollapseItemWrapBgColor: "#ffffff",
    elCollapseItemHeaderColor: "rgba(0, 0, 0, 0.8)",
    elCollapseItemContentColor: "rgba(0, 0, 0, 0.8)",
    elCollapseItemBorderColor: "rgba(0, 0, 0, 0.08)",
    elTreeActiveColor: "rgba(0, 133, 133, 1)",
    elTreeHoverColor: "rgba(23, 112, 255, 0.1)",
    editBgColor: "#F5F6F8",
    text: "rgba(0,0,0,1)",
    textColor: "rgba(0,0,0,.8)",
    sliderBackGround: "#e9e9e9",
    inputBackGround: "rgba(243, 243, 243, 1)",
    inputBorder: "1px solid #DCDFE6",
    inputPlaceHolderText: "rgba(255, 255, 255, 0.2)",
    inputIconHoverBgColor: "rgba(240, 242, 247, 1)",
    inputSuffixText: "black",
    inputDisabledColor: "rgba(0,0,0,0.2)",
    thirdTextColor: "rgba(0,0,0,.4)",
    fourthTextColor: "rgba(0,0,0,.2)",
    alertBackGround: "rgba(255, 255, 255, 0.3)",
    toolbarTipText: "rgba(0,0,0,0.4)",
    themeColorIcon: "rgba(0, 133, 133, 1)",
    themeColorIconHover: "rgba(0, 133, 133, 0.05)",
    themeColor: "rgba(0, 133, 133, 1)",
    themeColorHover: "rgba(0, 133, 133, .8)",
    themeColorDisabled: "rgba(0, 133, 133, .5)",
    themeColorSelectBg: "rgba(0, 133, 133, .1)",
    toobarTopBgColor: "rgba(244, 255, 255, 1)",
    cardBgColor: "rgba(251, 252, 253, 1)",
    subTextColor: "rgba(0, 0, 0, 0.6)",
    styleBgColor: "rgba(245, 246, 248, 1)",
    borderColorFour: "#DEE0E3",
    colorPickerInputColor: "rgba(233, 233, 233,1)",
    borderColorFive: "rgba(0, 0, 0, 0.07)",
    dataTableBgColor: "#fff",
    inputBg: "rgba(243, 243, 243, 1)",
    inputArrowBgColor: "#F5F6F8",
    inputArrowMousedownBgColor: "#DFE2E9",
    inputArrowHoverBgColor: "#E9ECF1",
    dialogBgColor: "#fff",
    rulerBgColor: "#FCFCFC",
    iconHoverBgColor: "rgba(0, 0, 0, 0.04)",
    borderColorSeven: "rgba(0,0,0,.12)",
    iconHoverBg: "rgba(0,0,0,.06)",
    iconColor: "rgba(113, 121, 137, 1)",
    collapsibleItemHeadingColor: "rgba(0, 0, 0, 0.8)",
    collapsibleItemHeadingAfterColor: "rgba(0, 0, 0, 0.4) transparent transparent transparent",
    collapsibleItemHeadingCollapseAfterColor: "transparent transparent transparent rgba(0, 0, 0, 0.4)",
    tipsBgColor: "rgba(24, 30, 51, 0.8)",
    borderColorEight: "rgb(233, 233, 233)",
    borderColorNine: "rgba(0, 0, 0, 0.07)",
    dataTableAddBgColor: "#FFFFFF",
    dataAddActiveBgColor: "#F9F9F9",
    borderColorTen: "#E9E9E9",
    operateBoxShadow:
      "0px 6px 16px -8px rgba(0, 0, 0, 0.08), 0px 9px 28px rgba(0, 0, 0, 0.05), 0px 12px 48px 16px rgba(0, 0, 0, 0.03)",
    cellSelectBgColor: "rgba(29, 114, 248, 0.2)",
    selectBorderColor: "rgba(0, 133, 133, 1)",
    collapsibleItemContentTextColor: "rgba(0, 0, 0, 0.6)",
    inputNuberHoverThemeBgColor: "rgba(235, 235, 235, 1)",
    borderColorEle: "rgba(0, 0, 0, 0.12)",
    dragMoveBgColor: "rgba(0, 133, 133, .2)",
    dragMoveBorderColor: "rgba(0, 133, 133, 1)",
    messageTipsBorderColor: "#E9E9E9",
    messageTipsBackgroundColor: "#FFFFFF",
    messageTipsBoxShaow: "0px 6px 16px -8px rgba(0, 0, 0, 0.08), 0px 8px 20px rgba(0, 0, 0, 0.12)",
    messageTipsBorderStyle: "none",
    paddingIconHoverColor: "rgba(0, 0, 0, 0.06)",
    imgDialogIconColor: "rgba(0,0,0,.4)",
    pageBottomSliderBg: "#B7B7B7",
    checkBoxActiveColor: "#409EFF",
    checkBoxEmptyColor: "#FFFFFF",
    checkBoxBorder: "1px solid rgba(0, 0, 0, 0.14)",
    bgColorPickerInputColor: "rgba(0, 0, 0, 0.8)",
    bgColorPickerInputBgColor: "#F0F0F0",
    bgColorPickerInputLabelColor: "rgba(0, 0, 0, 0.4)",
    defaultButtonHover: "#E8FFFB",
    primaryButtonHover: "rgba(255, 255, 255, 0.9)",
    topOperationBorderColor: "rgba(255, 255, 255, 0.32)",
    topOperationIconColor: "rgba(255, 255, 255, 0.8)",
    topOperationIconBgColor: "rgba(255, 255, 255, 0.9)",
    topSubTextColor: "rgba(255, 255, 255, 0.6)",
    topThirdTextColor: "rgba(255, 255, 255, 0.4)",
    topControlHoverBg: "rgba(255, 255, 255, 0.16)",
    topIconDisabled: "rgba(255,255,255,0.3)",
    selectItemHoverBg: "#F0F2F7",
    dialogShade: "rgba(255,255,255,0.6)",
    previewButtonHover: "rgba(255, 255, 255, 0.1)",
  },
  {
    rootBgColor: "#ffffff",
    leftMenuBgColor: "#ffffff",
    selectArrorIcon: "rgba(0,0,0,.8)",
    topOperationBgColor: "rgba(61, 130, 242, 1)",
    topOperationSaveColor: "rgba(61, 130, 242, 1)",
    topOperationColor: "rgba(255, 255, 255, 1)",
    topOperationAColor: "rgba(255, 255, 255, 1)",
    topOperationHoverColor: "rgba(255, 255, 255, 1)",
    elCollapseItemHeaderBgColor: "rgba(235, 242, 255, 1)",
    elCollapseItemWrapBgColor: "#ffffff",
    elCollapseItemHeaderColor: "rgba(0, 0, 0, 0.8)",
    elCollapseItemContentColor: "rgba(0, 0, 0, 0.8)",
    elCollapseItemBorderColor: "rgba(0, 0, 0, 0.08)",
    elTreeActiveColor: "rgba(61, 130, 242, 1)",
    elTreeHoverColor: "rgba(23, 112, 255, 0.1)",
    editBgColor: "#F5F6F8",
    text: "rgba(0,0,0,1)",
    textColor: "rgba(0,0,0,.8)",
    sliderBackGround: "#e9e9e9",
    inputBackGround: "rgba(243, 243, 243, 1)",
    inputBorder: "1px solid #DCDFE6",
    inputPlaceHolderText: "rgba(255, 255, 255, 0.2)",
    inputIconHoverBgColor: "rgba(240, 242, 247, 1)",
    inputSuffixText: "black",
    inputDisabledColor: "rgba(0,0,0,0.2)",
    thirdTextColor: "rgba(0,0,0,.4)",
    fourthTextColor: "rgba(0,0,0,.2)",
    alertBackGround: "rgba(255, 255, 255, 0.3)",
    toolbarTipText: "rgba(0,0,0,0.4)",
    themeColorIcon: "rgba(61, 130, 242, 1)",
    themeColorIconHover: "rgba(61, 130, 242, 0.05)",
    themeColor: "rgba(61, 130, 242, 1)",
    themeColorHover: "rgba(61, 130, 242, .8)",
    themeColorDisabled: "rgba(61, 130, 242, .5)",
    themeColorSelectBg: "rgba(61, 130, 242, .1)",
    toobarTopBgColor: "rgba(245, 248, 255, 1)",
    cardBgColor: "rgba(251, 252, 253, 1)",
    subTextColor: "rgba(0, 0, 0, 0.6)",
    styleBgColor: "rgba(245, 246, 248, 1)",
    borderColorFour: "#DEE0E3",
    colorPickerInputColor: "rgba(233, 233, 233,1)",
    borderColorFive: "rgba(0, 0, 0, 0.07)",
    dataTableBgColor: "#fff",
    inputBg: "rgba(243, 243, 243, 1)",
    inputArrowBgColor: "#F5F6F8",
    inputArrowMousedownBgColor: "#DFE2E9",
    inputArrowHoverBgColor: "#E9ECF1",
    dialogBgColor: "#fff",
    rulerBgColor: "#FCFCFC",
    iconHoverBgColor: "rgba(0, 0, 0, 0.04)",
    borderColorSeven: "rgba(0,0,0,.12)",
    iconHoverBg: "rgba(0,0,0,.06)",
    iconColor: "rgba(113, 121, 137, 1)",
    collapsibleItemHeadingColor: "rgba(0, 0, 0, 0.8)",
    collapsibleItemHeadingAfterColor: "rgba(0, 0, 0, 0.4) transparent transparent transparent",
    collapsibleItemHeadingCollapseAfterColor: "transparent transparent transparent rgba(0, 0, 0, 0.4)",
    tipsBgColor: "rgba(24, 30, 51, 0.8)",
    borderColorEight: "rgb(233, 233, 233)",
    borderColorNine: "rgba(0, 0, 0, 0.07)",
    dataTableAddBgColor: "#FFFFFF",
    dataAddActiveBgColor: "#F9F9F9",
    borderColorTen: "#E9E9E9",
    operateBoxShadow:
      "0px 6px 16px -8px rgba(0, 0, 0, 0.08), 0px 9px 28px rgba(0, 0, 0, 0.05), 0px 12px 48px 16px rgba(0, 0, 0, 0.03)",
    cellSelectBgColor: "rgba(29, 114, 248, 0.2)",
    selectBorderColor: "rgba(61, 130, 242, 1)",
    collapsibleItemContentTextColor: "rgba(0, 0, 0, 0.6)",
    inputNuberHoverThemeBgColor: "rgba(235, 235, 235, 1)",
    borderColorEle: "rgba(0, 0, 0, 0.12)",
    dragMoveBgColor: "rgba(61, 130, 242, .2)",
    dragMoveBorderColor: "rgba(61, 130, 242, 1)",
    messageTipsBorderColor: "#E9E9E9",
    messageTipsBackgroundColor: "#FFFFFF",
    messageTipsBoxShaow: "0px 6px 16px -8px rgba(0, 0, 0, 0.08), 0px 8px 20px rgba(0, 0, 0, 0.12)",
    messageTipsBorderStyle: "none",
    paddingIconHoverColor: "rgba(0, 0, 0, 0.06)",
    imgDialogIconColor: "rgba(0,0,0,.4)",
    pageBottomSliderBg: "#B7B7B7",
    checkBoxActiveColor: "#409EFF",
    checkBoxEmptyColor: "#FFFFFF",
    checkBoxBorder: "1px solid rgba(0, 0, 0, 0.14)",
    bgColorPickerInputColor: "rgba(0, 0, 0, 0.8)",
    bgColorPickerInputBgColor: "#F0F0F0",
    bgColorPickerInputLabelColor: "rgba(0, 0, 0, 0.4)",
    defaultButtonHover: "#E8F2FF",
    primaryButtonHover: "rgba(255, 255, 255, 0.9)",
    topOperationBorderColor: "rgba(255, 255, 255, 0.32)",
    topOperationIconColor: "rgba(255, 255, 255, 0.8)",
    topOperationIconBgColor: "rgba(255, 255, 255, 0.9)",
    topSubTextColor: "rgba(255, 255, 255, 0.6)",
    topThirdTextColor: "rgba(255, 255, 255, 0.4)",
    topControlHoverBg: "rgba(255, 255, 255, 0.16)",
    topIconDisabled: "rgba(255,255,255,0.3)",
    selectItemHoverBg: "#F0F2F7",
    dialogShade: "rgba(255,255,255,0.6)",
    previewButtonHover: "rgba(255, 255, 255, 0.1)",
  }
]
import plugins from "./pagePlugin/index"
import { hasProperty, getHomePageName } from "@/utils"
import { updateSubPageMapping } from "utils/updateData/publicDataUtils/subPageUpdateData.js"
export default {
  name: "App",
  mixins: [plugins],
  watch: {
    "$route.query": {
      deep: true,
      immediate: true,
      handler(n, o) {
        if (n.showPluginSetting || n.ss) {
          this.$store.commit("states/changeShowPluginSetting", true)
        } else {
          this.$store.commit("states/changeShowPluginSetting", false)
        }
      }
    },
    "$store.state.bigScreen.page.pluginName": {
      deep: true,
      immediate: true,
      handler(n, o) {
        if (this.request_prefix === "bigScreen") {
          this.initPlugins()
        }
      }
    },
    "$store.state.stage.page.pluginName": {
      deep: true,
      immediate: true,
      handler(n, o) {
        if (n && o) {
          if (JSON.stringify(n) === JSON.stringify(o)) return
        }
        if (this.request_prefix === "stage") {
          this.initPlugins()
        }
      }
    },
    "$store.state.appStage.page.pluginName": {
      deep: true,
      immediate: true,
      handler(n, o) {
        if (this.request_prefix === "appStage") {
          this.initPlugins()
        }
      }
    },
    "$route.path"() {
      this.initStyle(this.styleColorId)
    },
    styleColorId(newVal, oldVal) {
      this.initStyle(newVal)
    },
    "$store.state.states.subPageEditInfo": {
      deep: true,
      handler(n, o) {
        if (n.edit && n.type === "setting") {
          this.updateSubPageSetting(n.value)
          this.$store.state.states.subPageEditInfo.edit = false
        }
      }
    }
  },
  mounted() {
    console.log("this.request_prefix 1:>> ", this.request_prefix)
    document.addEventListener("paste", this.pasteHandle)
    this.$store.commit("states/clearHistoryState")
  },
  beforeDestroy() {
    themeColors = null
    types = null
    document.removeEventListener("paste", this.pasteHandle)
  },
  computed: {
    styleColorId() {
      return this.$store.state[this.request_prefix].page.editPageThemeColor || 0
    },
    bgStyle() {
      let containerOptions
      if (this.$store.state.bigScreen.page.stageType === "layOut") {
        containerOptions = JSON.parse(JSON.stringify(this.$store.state.bigScreen.page.layoutOption))
      } else {
        containerOptions = JSON.parse(JSON.stringify(this.$store.state.bigScreen.page.children[0].options))
      }

      if (!containerOptions) {
        return {}
      }
      let conatinerBg = {
        backgroundImage: "",
        height: this.stageHeight
      }
      if (!containerOptions.background || !Array.isArray(containerOptions.background)) {
        containerOptions.background = [
          {
            type: "color",
            label: "颜色",
            isThemeColor: false,
            color: containerOptions.bgColor || "#fff"
          }
        ]
      }
      containerOptions.background.forEach(bg => {
        switch (bg.type) {
          case "color":
            // conatinerBg.backgroundColor = bg.isThemeColor
            //   ? this.$store.state[this.request_prefix].page.themeColor
            //   : bg.color
            conatinerBg.backgroundColor = this.$parseColor(bg)
            break
          case "linearGradient":
            let tmp = []
            if (bg.data.stops.length > 0) {
              // bg.data.stops.forEach(item => {
              //   tmp.push(item[0] + " " + item[1] * 100 + "%")
              // })
              let dot = conatinerBg.backgroundImage.length > 0 ? "," : ""
              // conatinerBg.backgroundImage += dot + "linear-gradient(" + bg.data.angle + "deg," + tmp.join(",") + ")"
              conatinerBg.backgroundImage += dot + this.$parseColor(bg)
            }
            break
          case "radialGradient":
            let radialTmp = []
            if (bg.data.stops.length > 0) {
              // bg.data.stops.forEach(item => {
              //   radialTmp.push(item[0] + " " + item[1] * 100 + "%")
              // })
              let dot = conatinerBg.backgroundImage.length > 0 ? "," : ""
              // conatinerBg.backgroundImage +=
              //   dot + "radial-gradient(at " + bg.data.siteX + "% " + bg.data.siteY + "%," + radialTmp.join(",") + ")"
              conatinerBg.backgroundImage += dot + this.$parseColor(bg)
            }
            break
          default:
        }
      })
      return { ...conatinerBg }
    },
    isListPage() {
      return this.$store.state.states.getDataPageIds.pv === "1"
    }
  },
  methods: {
    async initPlugins() {
      let pluginName = this.$store.state[this.request_prefix].page.pluginName
      if (pluginName) {
        const exp = /^fetch-(.+)-sync$/
        // 同步插件数量，执行完成了，才进行后续操作
        let syncPluginNum = pluginName.filter(plugin => exp.test(plugin.trim())).length
        if (!syncPluginNum) {
          this.$store.state.states.loadingSyncPlugins = false
        } else {
          this.$store.state.states.loadingSyncPlugins = true
        }
        for (let i = 0; i < pluginName.length; i++) {
          let name = pluginName[i].trim()
          const result = exp.exec(name)
          if (result !== null) {
            let v = Date.now()
            this.instance.get(`sv2/assets/plugs_v2/${result[1]}.json?v=${v}`).then(res => {
              const fnStr = res?.data?.content
              if (fnStr && typeof fnStr === "string") {
                const fn = new Function("ctx", fnStr)
                fn(this)
                syncPluginNum--
                syncPluginNum === 0 && (this.$store.state.states.loadingSyncPlugins = false)
              }
            })
          }
        }

        // 异步插件
        pluginName = pluginName.filter(plugin => {
          return !plugin.trim().endsWith("-sync")
        })
        if (
          this.$store.state[this.request_prefix].type === "detailPage" ||
          this.$store.state[this.request_prefix].type === "listPage"
        ) {
          // getHomePageName(this)
          const plugins = [...pluginName].filter(it => it.trim().length)
          plugins.forEach(item => {
            if (hasProperty(this, item) && typeof this[item] === "function") {
              this[item]()
            }else{
              let name = item
              const fetchTag = "fetch-"
              if (name.includes(fetchTag) && name.length > fetchTag.length) {
                let v = Date.now()
                this.instance
                  .get(`sv2/assets/plugs_v2/${name.slice(name.indexOf(fetchTag) + fetchTag.length)}.json?v=${v}`)
                  .then(res => {
                    const fnStr = res?.data?.content
                    if (fnStr && typeof fnStr === "string") {
                      const fn = new Function("ctx", fnStr)
                      fn(this)
                    }
                  })
              }
            }
          })
        } else {
          for (let i = 0; i < pluginName.length; i++) {
            let name = pluginName[i]
            const fetchTag = "fetch-"
            if (name.includes(fetchTag) && name.length > fetchTag.length) {
              let v = Date.now()
              this.instance
                .get(`sv2/assets/plugs_v2/${name.slice(name.indexOf(fetchTag) + fetchTag.length)}.json?v=${v}`)
                .then(res => {
                  const fnStr = res?.data?.content
                  if (fnStr && typeof fnStr === "string") {
                    const fn = new Function("ctx", fnStr)
                    fn(this)
                  }
                })
            }
          }
        }
      } else {
        this.$store.state.states.loadingSyncPlugins = false
      }
    },
    initStyle(colorId) {
      if (location.href.includes("uiModule") || this.isBigScreenPreview()) return
      const pathname = window.location.pathname
      let themeName = pathname.split("/").pop() + "ThemeColor"
      let styles = ""

      if (themeName.toLowerCase().indexOf("home") > -1) {
        themeColors[themeName] = preStyleColors[colorId]
      }
      for (let i = 0; i < types.length; i++) {
        if (themeColors[themeName] && themeColors[themeName][types[i]]) {
          styles += `--${types[i]}:${themeColors[themeName][types[i]]};`
        }
      }
      this.$el.parentNode.setAttribute("style", styles)
    },
    // 去掉粘贴文本中的样式，只保留文本
    pasteHandle(e) {
      e.preventDefault()
      let text = null
      if (window.clipboardData && window.clipboardData.getData) {
        text = window.clipboardData.getData("text")
      } else if (e.clipboardData && e.clipboardData.getData) {
        text = e.clipboardData.getData("text/plain")
      }
      if (document.queryCommandSupported("insertText")) {
        document.execCommand("insertText", false, text)
      } else {
        document.execCommand("paste", false, text)
      }
    },
    // 监听当前子页面设置变化
    updateSubPageSetting(type) {
      if (this.isListPage) {
        let pluginName = this.$store.state[this.request_prefix].page.pluginName
        if (pluginName && pluginName.indexOf("searchListPagePlugin") > -1) {
          this.handleSearchListPageSetting(type)
        } else {
          this.handleListPageSetting(type)
        }
      } else {
        this.handleDetailPageSetting(type)
      }
    }
  }
}
</script>

<style>
html,
body {
  height: 100%;
}
#app {
  min-width: 100%;
  min-height: 100%;
  background-color: var(--rootBgColor);
}
/**
  左侧菜单栏样式
   */
.menu,
.right-toolbar {
  background-color: var(--leftMenuBgColor) !important;
}
.el-collapse-item__header {
  background: var(--elCollapseItemHeaderBgColor) !important;
  color: var(--elCollapseItemHeaderColor) !important;
}
.el-collapse-item__wrap {
  background: var(--elCollapseItemWrapBgColor) !important;
}
.el-collapse-item__content {
  color: var(--elCollapseItemContentColor) !important;
}

/**
input框右侧按钮hover背景颜色
*/
.right-handle-icon:hover {
  background-color: var(--paddingIconHoverColor) !important;
}
.right-handle-icon:hover::before {
  color: var(--collapsibleItemContentTextColor) !important;
}
.stop-blank {
  flex: 1;
  height: 100%;
}
/**
drawer抽屉遮罩层样式
*/
.cutome-drawer-modal {
  position: fixed;
  left: 220px;
  top: 50px;
  width: calc(100% - 480px);
  height: 100%;
  /* opacity: 0.5;
  background: #000; */
}
.cutome-drawer-modal-mobile {
  position: fixed;
  left: calc(50% - 227px);
  top: 50px;
  width: 414px;
  height: 100%;
  /* opacity: 0.5;
  background: #000; */
}
/*修改默认弹框样式*/
.v-modal {
  opacity: 0.4;
}
</style>
